import { NgModule } from '@angular/core';
import { MpApiErrorMessageComponent } from './mp-api-error-message.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MpFuncionnalErrorLabelModule } from '../mp-functionnal-error-label/mp-functionnal-error-label.module';
import { MP_SNACKBAR_DATA, MP_SNACKBAR_REF } from '../mp-snackbar/mp-snackbar.tokens';

@NgModule({
  declarations: [MpApiErrorMessageComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslateModule,
    MpFuncionnalErrorLabelModule
  ],
  exports: [MpApiErrorMessageComponent],
  providers: [
    { provide: MP_SNACKBAR_DATA, useValue: MP_SNACKBAR_DATA },
    { provide: MP_SNACKBAR_REF, useValue: MP_SNACKBAR_REF }
  ]
})
export class MpApiErrorMessageModule {}
